import GeoCodeService from './GeoCodeService';
import 'ngGMaps';
import 'portalConfig';

export default angular.module('edge.platform.map', ['portal.config', 'ngMap']).service('GeoCodeService', GeoCodeService);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/map/module.js
// module id = 102
// module chunks = 0